import { render, staticRenderFns } from "./TitleHeaderModule.vue?vue&type=template&id=17ded9f6&"
import script from "./TitleHeaderModule.ts?vue&type=script&lang=ts&"
export * from "./TitleHeaderModule.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports